import useTranslations from "../../../../core/i18n/useTranslations";
import PrimeModal from "../../../../ui-lib/components/PrimeModal/PrimeModal";
import { useState } from "react";

export const OverlapModal = ({
  isOpen,
  isEdit,
  onSubmit,
  onClose,
}: {
  isOpen: boolean;
  isEdit: boolean;
  onSubmit: () => Promise<void>;
  onClose: () => void;
}) => {
  const t = useTranslations();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <PrimeModal
      withFooter
      withHeader
      isOpen={isOpen}
      onClose={onClose}
      fixedWidth="576px"
      header={
        isEdit
          ? t("Objects:edit_scheduled_absence")
          : t("Objects:confirm_new_absence_event")
      }
      loading={isLoading}
      submitBtn={{
        text: isEdit ? t("Common:label_edit") : t("Common:yes_create"),
        onClick: async () => {
          setIsLoading(true);
          await onSubmit();
          setIsLoading(false);
        },
        disabled: isLoading,
      }}
      cancelBtn={{ text: t("Common:no_cancel"), onClick: onClose }}
    >
      <p style={{ color: "var(--Grey-600)" }}>
        {t("Objects:absence_overlap_text")}
      </p>
    </PrimeModal>
  );
};
